"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTrackProvider = void 0;
const api_1 = require("@streem/api");
const sdk_araas_1 = require("@streem/sdk-araas");
const sdk_twilio_video_1 = require("@streem/sdk-twilio-video");
const sdk_chime_video_1 = require("@streem/sdk-chime-video");
const buildTrackProvider = (callSettings, observables, isHostSession, roomId) => {
    const platform = callSettings.videoPlatform;
    if (platform === api_1.StreemApiDeviceSupportedVideoPlatforms.ARAAS) {
        return new sdk_araas_1.AraasRoom({
            roomVideoCredentials: callSettings.roomVideoCredentials,
            remoteParticipantCapabilities: observables.remoteParticipantCapabilities,
        });
    }
    else if (platform === api_1.StreemApiDeviceSupportedVideoPlatforms.TWILIO) {
        return new sdk_twilio_video_1.TwilioRoom({
            roomVideoCredentials: callSettings.roomVideoCredentials,
            remoteParticipantCapabilities: observables.remoteParticipantCapabilities,
            isHostSession,
        });
    }
    else if (platform === api_1.StreemApiDeviceSupportedVideoPlatforms.CHIME) {
        return new sdk_chime_video_1.ChimeRoom({
            roomVideoCredentials: callSettings.roomVideoCredentials,
            remoteParticipantCapabilities: observables.remoteParticipantCapabilities,
            isHostSession,
            streemRoomId: roomId,
            chimeLowBandwidthOptimizationEnabled: callSettings.chimeLowBandwidthOptimizationEnabled,
            preferredVideoCodecs: callSettings.preferredVideoCodecs,
        });
    }
    else {
        throw new Error('Invalid video platform');
    }
};
exports.buildTrackProvider = buildTrackProvider;
//# sourceMappingURL=track_provider_builder.js.map